import React, { useState } from "react";

function SelectBankAccountModal({ 
  isOpen, 
  onClose, 
  onSelectExisting, 
  onAddNew,
  bankAccounts = []
}) {
  const [step, setStep] = useState('choose'); // 'choose' or 'select_existing'
  const [selectedBankAccountId, setSelectedBankAccountId] = useState(null);

  if (!isOpen) return null;

  const handleSelectExisting = () => {
    setStep('select_existing');
  };

  const handleAddNew = () => {
    setStep('choose');
    setSelectedBankAccountId(null);
    onAddNew();
  };

  const handleConfirmSelection = () => {
    if (selectedBankAccountId) {
      setStep('choose');
      setSelectedBankAccountId(null);
      onSelectExisting(selectedBankAccountId);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">
            {step === 'choose' ? 'Choose Bank Account' : 'Select Existing Bank Account'}
          </h2>
        </div>

        <div className="p-6">
          {step === 'choose' ? (
            <div className="space-y-4">
              <button
                onClick={handleSelectExisting}
                className="w-full p-4 border-2 border-gray-300 rounded-lg hover:border-emerald-500 hover:bg-emerald-50 transition-all text-left"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Choose from existing bank accounts</h3>
                    <p className="text-sm text-gray-500">Select a bank account already added to this household</p>
                  </div>
                </div>
              </button>

              <button
                onClick={handleAddNew}
                className="w-full p-4 border-2 border-gray-300 rounded-lg hover:border-emerald-500 hover:bg-emerald-50 transition-all text-left"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 bg-emerald-100 rounded-full flex items-center justify-center">
                    <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900">Add a new bank account</h3>
                    <p className="text-sm text-gray-500">Add a new bank account to the household</p>
                  </div>
                </div>
              </button>
            </div>
          ) : (
            <div className="space-y-4">
              <p className="text-sm text-gray-600">Select a bank account to link:</p>
              <div className="space-y-2 max-h-96 overflow-y-auto">
                {bankAccounts.length > 0 ? (
                  bankAccounts.map((ba) => (
                    <div
                      key={ba.id}
                      onClick={() => setSelectedBankAccountId(ba.id)}
                      className={`p-4 border-2 rounded-lg cursor-pointer transition-all ${
                        selectedBankAccountId === ba.id
                          ? 'border-emerald-500 bg-emerald-50'
                          : 'border-gray-200 hover:border-emerald-300'
                      }`}
                    >
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="font-medium text-gray-900">{ba.account_name || 'N/A'}</p>
                          <p className="text-sm text-gray-500">{ba.bank_name || 'N/A'} - {ba.account_number || 'N/A'}</p>
                        </div>
                        {selectedBankAccountId === ba.id && (
                          <svg className="w-6 h-6 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                          </svg>
                        )}
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-gray-500 py-4">No bank accounts available</p>
                )}
              </div>

              <div className="flex gap-3 mt-4">
                <button
                  onClick={() => setStep('choose')}
                  className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Back
                </button>
                <button
                  onClick={handleConfirmSelection}
                  disabled={!selectedBankAccountId}
                  className="flex-1 px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors"
                >
                  Select Bank Account
                </button>
              </div>
            </div>
          )}
        </div>

        {step === 'choose' && (
          <div className="px-6 py-4 bg-gray-50 border-t border-gray-200 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors"
            >
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default SelectBankAccountModal;
